import React from 'react';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/bootstrap.css";

export const CommonPhoneInput = ({ country, value, onChange, onBlur, touched, errors }) => {
    return (
        <div>
            <PhoneInput 
                country={country}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                className={`form-control border-0 p-0 ${touched && errors ? 'is-invalid' : ''}`}
            />
            {touched && errors && (
                <div className="invalid-feedback">
                    {errors}
                </div>
            )}
        </div>
    );
}